var T = "bquery-sanitizer", U = /* @__PURE__ */ new Set([
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "button",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "i",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "nav",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "u",
  "ul",
  "var",
  "wbr"
]), S = /* @__PURE__ */ new Set([
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "link",
  "meta",
  "style",
  "base",
  "template",
  "math",
  "svg",
  "foreignobject",
  "noscript"
]), O = /* @__PURE__ */ new Set([
  "document",
  "window",
  "location",
  "top",
  "self",
  "parent",
  "frames",
  "history",
  "navigator",
  "screen",
  "alert",
  "confirm",
  "prompt",
  "eval",
  "function",
  "cookie",
  "domain",
  "referrer",
  "body",
  "head",
  "forms",
  "images",
  "links",
  "scripts",
  "children",
  "parentnode",
  "firstchild",
  "lastchild",
  "innerhtml",
  "outerhtml",
  "textcontent"
]), F = /* @__PURE__ */ new Set([
  "alt",
  "class",
  "dir",
  "height",
  "hidden",
  "href",
  "id",
  "lang",
  "loading",
  "name",
  "rel",
  "role",
  "src",
  "srcset",
  "tabindex",
  "target",
  "title",
  "type",
  "width",
  "aria-*"
]), W = [
  "on",
  "formaction",
  "xlink:",
  "xmlns:"
], k = [
  "javascript:",
  "data:",
  "vbscript:",
  "file:"
], z = (e, t, r) => {
  const a = e.toLowerCase();
  for (const l of W) if (a.startsWith(l)) return !1;
  return r && a.startsWith("data-") || a.startsWith("aria-") ? !0 : t.has(a);
}, M = (e) => {
  const t = e.toLowerCase().trim();
  return !O.has(t);
}, P = (e) => e.replace(/[\u0000-\u001F\u007F]+/g, "").replace(/[\u200B-\u200D\uFEFF\u2028\u2029]+/g, "").replace(/\\u[\da-fA-F]{4}/g, "").replace(/\s+/g, "").toLowerCase(), L = (e) => {
  const t = P(e);
  for (const r of k) if (t.startsWith(r)) return !1;
  return !0;
}, q = (e) => {
  const t = e.split(",");
  for (const r of t) {
    const a = r.trim().split(/\s+/)[0];
    if (a && !L(a)) return !1;
  }
  return !0;
}, I = (e) => {
  try {
    const t = e.trim();
    if (t.startsWith("//")) return !0;
    const r = t.toLowerCase();
    return /^[a-z][a-z0-9+.-]*:/i.test(t) && !r.startsWith("http://") && !r.startsWith("https://") ? !0 : !r.startsWith("http://") && !r.startsWith("https://") ? !1 : typeof window > "u" || !window.location ? !0 : new URL(t, window.location.href).origin !== window.location.origin;
  } catch {
    return !0;
  }
}, V = (e) => new DOMParser().parseFromString(e, "text/html"), A = (e) => {
  const t = (typeof e == "string" ? e : String(e ?? "")).trim(), r = document.createDocumentFragment();
  if (t.length === 0) return r;
  if (!(t.includes("<") || t.includes(">")))
    return r.appendChild(document.createTextNode(t)), r;
  const a = V(t).body;
  if (!a) return r;
  for (; a.firstChild; ) r.appendChild(a.firstChild);
  return r;
}, f = (e, t = {}) => {
  const { allowTags: r = [], allowAttributes: a = [], allowDataAttributes: l = !0, stripAllTags: _ = !1 } = t, x = new Set([...U, ...r.map((n) => n.toLowerCase())].filter((n) => !S.has(n))), H = /* @__PURE__ */ new Set([...F, ...a.map((n) => n.toLowerCase())]), c = A(e);
  if (_) return c.textContent ?? "";
  const g = document.createTreeWalker(c, NodeFilter.SHOW_ELEMENT), p = [];
  for (; g.nextNode(); ) {
    const n = g.currentNode, i = n.tagName.toLowerCase();
    if (S.has(i)) {
      p.push(n);
      continue;
    }
    if (!x.has(i)) {
      p.push(n);
      continue;
    }
    const u = [];
    for (const o of Array.from(n.attributes)) {
      const s = o.name.toLowerCase();
      if (!z(s, H, l)) {
        u.push(o.name);
        continue;
      }
      if ((s === "id" || s === "name") && !M(o.value)) {
        u.push(o.name);
        continue;
      }
      if ((s === "href" || s === "src" || s === "action") && !L(o.value)) {
        u.push(o.name);
        continue;
      }
      s === "srcset" && !q(o.value) && u.push(o.name);
    }
    for (const o of u) n.removeAttribute(o);
    if (i === "a") {
      const o = n.getAttribute("href"), s = n.getAttribute("target")?.toLowerCase() === "_blank", D = o && I(o);
      if (s || D) {
        const y = n.getAttribute("rel"), m = new Set(y ? y.split(/\s+/).filter(Boolean) : []);
        m.add("noopener"), m.add("noreferrer"), n.setAttribute("rel", Array.from(m).join(" "));
      }
    }
  }
  for (const n of p) n.remove();
  const w = (n) => {
    const i = document.createElement("div");
    return i.appendChild(n.cloneNode(!0)), i.innerHTML;
  }, b = w(c), v = w(A(b));
  return b !== v ? c.textContent ?? "" : v;
}, R = /* @__PURE__ */ Symbol("bquery.trusted-html.brand"), h = /* @__PURE__ */ Symbol("bquery.trusted-html"), j = (e) => e, B = (e) => {
  const t = String(e);
  return Object.freeze({
    [R]: !0,
    [h]: t,
    toString: () => t
  });
}, $ = (e) => typeof e == "object" && e !== null && R in e && h in e, X = (e) => e[h], E = 1024, C = 8192, K = (e = 16) => {
  if (!Number.isInteger(e) || e < 1) throw new RangeError("generateNonce length must be a positive integer");
  if (e > E) throw new RangeError(`generateNonce length must not exceed ${E}`);
  if (typeof globalThis.crypto > "u" || typeof globalThis.crypto.getRandomValues != "function") throw new Error("generateNonce requires crypto.getRandomValues (not available in this environment)");
  if (typeof globalThis.btoa != "function") throw new Error("generateNonce requires btoa (not available in this environment)");
  const t = new Uint8Array(e);
  globalThis.crypto.getRandomValues(t);
  let r = "";
  for (let a = 0; a < t.length; a += C) {
    const l = t.subarray(a, Math.min(a + C, t.length));
    r += String.fromCharCode(...l);
  }
  return globalThis.btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}, Q = (e) => {
  if (typeof document > "u") return !1;
  const t = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  return t ? (t.getAttribute("content") ?? "").includes(e) : !1;
}, d = null, N = !1, Y = () => typeof window < "u" && typeof window.trustedTypes < "u", G = () => {
  if (d) return d;
  if (N || typeof window > "u") return null;
  const e = window;
  if (!e.trustedTypes) return null;
  N = !0;
  try {
    return d = e.trustedTypes.createPolicy(T, { createHTML: (t) => f(t) }), d;
  } catch (t) {
    const r = t instanceof Error ? t.message : String(t);
    return console.warn(`bQuery: Could not create Trusted Types policy "${T}": ${r}`), null;
  }
}, Z = (e) => {
  const t = G();
  return t ? t.createHTML(e) : f(e);
}, J = (e, t = {}) => j(f(e, t)), ee = (e) => {
  const t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  };
  return e.replace(/[&<>"'`]/g, (r) => t[r]);
}, te = (e) => f(e, { stripAllTags: !0 });
export {
  U as _,
  G as a,
  Q as c,
  B as d,
  X as f,
  F as g,
  S as h,
  Z as i,
  $ as l,
  k as m,
  J as n,
  Y as o,
  W as p,
  te as r,
  K as s,
  ee as t,
  j as u,
  O as v
};

//# sourceMappingURL=sanitize-DOMkRO9G.js.map